export default __webpack_public_path__ + "static/media/logo192x192.80c30214.png";